import { mmidPrefixSize } from "../config/const"


export const generateSubjectPrefix = (): string => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < mmidPrefixSize; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}
